__turbopack_context__.v({
  "New": "programs-module-scss-module__QTQg4a__New",
  "Popular": "programs-module-scss-module__QTQg4a__Popular",
  "arrowContainer": "programs-module-scss-module__QTQg4a__arrowContainer",
  "category": "programs-module-scss-module__QTQg4a__category",
  "categoryTitle": "programs-module-scss-module__QTQg4a__categoryTitle",
  "exploreCTA": "programs-module-scss-module__QTQg4a__exploreCTA",
  "leftArrow": "programs-module-scss-module__QTQg4a__leftArrow",
  "open": "programs-module-scss-module__QTQg4a__open",
  "programHeadTitle": "programs-module-scss-module__QTQg4a__programHeadTitle",
  "programListTitle": "programs-module-scss-module__QTQg4a__programListTitle",
  "programWrapper": "programs-module-scss-module__QTQg4a__programWrapper",
  "programsListingMainContainer": "programs-module-scss-module__QTQg4a__programsListingMainContainer",
  "programsListingWrapper": "programs-module-scss-module__QTQg4a__programsListingWrapper",
  "programsWrapper": "programs-module-scss-module__QTQg4a__programsWrapper",
  "rightArrow": "programs-module-scss-module__QTQg4a__rightArrow",
  "tag": "programs-module-scss-module__QTQg4a__tag",
});
